const reactiveToggleHiderSelects = document.querySelectorAll(
  'select[data-show-elements-if-values-match]'
);

export default function initReactiveToggleHiderSelects() {
  reactiveToggleHiderSelects.forEach((select) => {
    // initial run
    checkReactiveToggleHiderSelectForMatchingValues(select);

    // set up event listeners for changes on the selects
    select.addEventListener('change', (event) => {
      checkReactiveToggleHiderSelectForMatchingValues(event.target);
    });
  });
}

function checkReactiveToggleHiderSelectForMatchingValues(selectEl) {
  const selectValue = selectEl.value;
  if (!selectValue && selectValue !== '') {
    return false;
  }

  const toggleData = selectEl.dataset.showElementsIfValuesMatch;
  if (!toggleData) return false;

  const dataObj = JSON.parse(toggleData);

  for (const selector in dataObj) {
    // console.log('selector: ', selector);

    // get toggling values as a comma separated array
    const togglingValuesArr = dataObj[selector]
      .split(',')
      .map((cell) => cell.trim());
    if (!togglingValuesArr) return false;
    // console.log('togglingValuesArr: ', togglingValuesArr);

    // get target el
    const hiders = document.querySelectorAll(selector);
    if (!hiders) return false;
    // console.log('hiders: ', hiders);

    hiders.forEach((hider) => {
      // toggle hidden attribute on the 'hider' based on whether the select's value matches an item in the toggling values array
      hider.hidden = !togglingValuesArr.includes(selectValue);

      // tells the element what the toggler's value is
      hider.dataset.togglerValue = selectValue;
    });
  }
}
